import navigationData from "../data/navigation.json";

export const currentSeason = navigationData.season;